module.exports = __webpack_public_path__ + "assets/img/d893bb7585a87c92cd42e1320f76ac20.svg";